import React, { useState, useEffect, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const slides = [
  {
    word: "TRANSFORM",
    letterImages: [
      { src: null, gapIndex: null },
      {
        src: "/images/Pende Minganji mask- Democratic Republic of the Congo.webp",
        alt: "Pende Minganji mask",
        gapIndex: 2,
        imageWidth: { mobile: 50, tablet: 90, desktop: 160, large: 200, xlarge: 240 },
        scale: { mobile: 0.8, tablet: 1, desktop: 1.2, large: 1.4, xlarge: 1.6 },
      },
      { src: null, gapIndex: null },
      {
        src: "/images/Discover Big Page/Mask 1.png",
        alt: "Mask",
        gapIndex: 5,
        imageWidth: { mobile: 50, tablet: 90, desktop: 160, large: 200, xlarge: 240 },
        scale: { mobile: 0.8, tablet: 1, desktop: 1.1, large: 1.3, xlarge: 1.5 },
      },
      { src: null, gapIndex: null },
      {
        src: "/images/Discover Big Page/Art.png",
        alt: "Art",
        gapIndex: 7,
        imageWidth: { mobile: 50, tablet: 90, desktop: 160, large: 200, xlarge: 240 },
        scale: { mobile: 0.8, tablet: 1, desktop: 1.2, large: 1.4, xlarge: 1.6 },
      },
      { src: null, gapIndex: null },
    ],
    bgColor: "#1a0a0a",
    enterFrom: { x: -1200, y: 120 },
    exitTo: { x: -900, y: -600 },
  },
  {
    word: "CONNECT",
    letterImages: [
      { src: null, gapIndex: null },
      {
        src: "/images/Pyramids of Meroe in Sudan.png",
        alt: "Pyramids of Meroe",
        gapIndex: 1,
        imageWidth: { mobile: 50, tablet: 90, desktop: 160, large: 200, xlarge: 240 },
        scale: { mobile: 0.8, tablet: 1, desktop: 1.2, large: 1.4, xlarge: 1.6 },
      },
      { src: null, gapIndex: null },
      {
        src: "/images/Discover Big Page/Pendant- Akan peoples.png",
        alt: "Akan Pendant",
        gapIndex: 3,
        imageWidth: { mobile: 50, tablet: 90, desktop: 160, large: 200, xlarge: 240 },
        scale: { mobile: 0.8, tablet: 1, desktop: 1.2, large: 1.4, xlarge: 1.6 },
      },
      { src: null, gapIndex: null },
      {
        src: "/images/Discover Big Page/Mask.png",
        alt: "Mask 2",
        gapIndex: 5,
        imageWidth: { mobile: 50, tablet: 90, desktop: 160, large: 200, xlarge: 240 },
        scale: { mobile: 0.8, tablet: 1, desktop: 1.2, large: 1.4, xlarge: 1.6 },
      },
      { src: null, gapIndex: null },
    ],
    bgColor: "#0a1a1a",
    enterFrom: { x: 1200, y: -120 },
    exitTo: { x: 900, y: -600 },
  },
  {
    word: "DESIGN",
    letterImages: [
      { src: null, gapIndex: null },
      {
        src: "/images/The Mendès-France Baule mask- Ivory Coast.webp",
        alt: "Baule mask",
        gapIndex: 1,
        imageWidth: { mobile: 50, tablet: 90, desktop: 160, large: 200, xlarge: 240 },
        scale: { mobile: 0.8, tablet: 1, desktop: 1.2, large: 1.4, xlarge: 1.6 },
      },
      { src: null, gapIndex: null },
      {
        src: "/images/Discover Big Page/Art.png",
        alt: "Art",
        gapIndex: 3,
        imageWidth: { mobile: 50, tablet: 90, desktop: 160, large: 200, xlarge: 240 },
        scale: { mobile: 0.8, tablet: 1, desktop: 1.2, large: 1.4, xlarge: 1.6 },
      },
      { src: null, gapIndex: null },
      {
        src: "/images/Discover Big Page/Mask 1.png",
        alt: "Mask",
        gapIndex: 5,
        imageWidth: { mobile: 50, tablet: 90, desktop: 160, large: 200, xlarge: 240 },
        scale: { mobile: 0.8, tablet: 1, desktop: 1.2, large: 1.4, xlarge: 1.6 },
      },
      { src: null, gapIndex: null },
    ],
    bgColor: "#1a1a0a",
    enterFrom: { x: 0, y: -1200 },
    exitTo: { x: -600, y: 900 },
  },
];

const SlideWord = ({ slide, imageIndex, letterHeight, isSlideTransition }) => {
  const letters = slide.word.split('');
  const current = slide.letterImages[imageIndex];

  const getResponsiveValue = (valueObj) => {
    if (typeof window === 'undefined') return valueObj.desktop;
    const w = window.innerWidth;
    if (w < 640) return valueObj.mobile;
    if (w < 1024) return valueObj.tablet;
    if (w < 1440) return valueObj.desktop;
    if (w < 1920) return valueObj.large;
    return valueObj.xlarge;
  };

  const vw = typeof window !== 'undefined' ? window.innerWidth : 1024;
  const defaultGap = vw < 640 ? 2 : vw < 1024 ? 4 : vw < 1440 ? 8 : vw < 1920 ? 10 : 12;

  const imageWidth = current.src ? getResponsiveValue(current.imageWidth) : 0;
  const currentScale = current.src ? getResponsiveValue(current.scale) : 1;

  const getImageVariants = () => {
    if (isSlideTransition) {
      return {
        initial: { opacity: 0, x: slide.enterFrom.x, y: slide.enterFrom.y, scale: 1 },
        animate: {
          opacity: 1, x: 0, y: 0, scale: 1,
          transition: {
            delay: 2, duration: 4.5, ease: [0.05, 0.9, 0.1, 1],
            opacity: { delay: 2, duration: 2 },
          },
        },
        exit: {
          opacity: 0, x: slide.exitTo.x, y: slide.exitTo.y, scale: 1,
          transition: {
            delay: 2, duration: 3.2, ease: [0.55, 0, 0.85, 0.1],
            opacity: { delay: 2, duration: 1.5 },
          },
        },
      };
    }
    return {
      initial: { opacity: 0, scale: 0.82, y: 18, x: 0 },
      animate: {
        opacity: 1, scale: 1, y: 0, x: 0,
        transition: { duration: 1.6, ease: [0.16, 1, 0.3, 1] },
      },
      exit: {
        opacity: 0, scale: 0.78, y: -18, x: 0,
        transition: { duration: 1.4, ease: [0.4, 0, 0.8, 0] },
      },
    };
  };

  const variants = getImageVariants();

  const renderGap = (gapIdx) => {
    const isActive = current.src && current.gapIndex === gapIdx;
    return (
      <motion.div
        key={`gap-${gapIdx}`}
        animate={{ width: isActive ? imageWidth : defaultGap }}
        transition={{ duration: 2.5, delay: isActive && isSlideTransition ? 2 : 0, ease: [0.33, 0.1, 0.2, 1] }}
        className="relative flex items-center justify-center shrink-0"
        style={{ height: letterHeight }}
      >
        <AnimatePresence mode="wait">
          {isActive && (
            <motion.img
              key={`${imageIndex}-gap-${gapIdx}`}
              src={current.src}
              alt={current.alt}
              initial={variants.initial}
              animate={variants.animate}
              exit={variants.exit}
              className="object-contain drop-shadow-2xl"
              style={{
                height: letterHeight * currentScale,
                maxWidth: '100%',
                display: 'block',
              }}
            />
          )}
        </AnimatePresence>
      </motion.div>
    );
  };

  return (
    <motion.div
      initial={{ x: slide.enterFrom.x, y: slide.enterFrom.y, opacity: 0 }}
      animate={{
        x: 0, y: 0, opacity: 1,
        transition: { duration: 4.5, ease: [0.05, 0.9, 0.1, 1] },
      }}
      exit={{
        x: slide.exitTo.x, y: slide.exitTo.y, opacity: 0,
        transition: { duration: 3.2, ease: [0.55, 0, 0.85, 0.1] },
      }}
      className="flex items-center justify-center select-none"
      style={{ height: letterHeight, flexWrap: 'nowrap' }}
    >
      {letters.map((letter, i) => (
        <React.Fragment key={i}>
          {renderGap(i)}
          <span
            style={{
              fontFamily: "'Ojuju', sans-serif",
              fontSize: `clamp(18px, 6vw, ${letterHeight}px)`,
              height: letterHeight,
              lineHeight: letterHeight + 'px',
              color: 'white',
              fontWeight: 'bold',
              margin: 0,
              padding: 0,
              display: 'flex',
              alignItems: 'center',
              flexShrink: 0,
            }}
          >
            {letter}
          </span>
        </React.Fragment>
      ))}
      {renderGap(letters.length)}
    </motion.div>
  );
};

const ConnectSection = () => {
  const [activeSlide, setActiveSlide] = useState(0);
  const [imageIndex, setImageIndex] = useState(1);
  const [letterHeight, setLetterHeight] = useState(120);
  const [isSlideTransition, setIsSlideTransition] = useState(false);
  const isAnimating = useRef(false);

  useEffect(() => {
    const updateLayout = () => {
      const w = window.innerWidth;
      if (w < 480) setLetterHeight(36);
      else if (w < 640) setLetterHeight(44);
      else if (w < 768) setLetterHeight(56);
      else if (w < 1024) setLetterHeight(90);
      else if (w < 1440) setLetterHeight(120);
      else if (w < 1920) setLetterHeight(150);
      else setLetterHeight(180);
    };
    updateLayout();
    window.addEventListener('resize', updateLayout);
    return () => window.removeEventListener('resize', updateLayout);
  }, []);

  const handleSlideChange = (index) => {
    if (isAnimating.current || index === activeSlide) return;
    isAnimating.current = true;
    setIsSlideTransition(true);
    setActiveSlide(index);
    setImageIndex(1);
    setTimeout(() => {
      isAnimating.current = false;
      setIsSlideTransition(false);
    }, 8000);
  };

  const handleImagePrev = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsSlideTransition(false);
    setImageIndex(prev => (prev - 1 + slides[activeSlide].letterImages.length) % slides[activeSlide].letterImages.length);
  };

  const handleImageNext = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsSlideTransition(false);
    setImageIndex(prev => (prev + 1) % slides[activeSlide].letterImages.length);
  };

  const bounceAnimation = {
    x: [0, 20, 0],
    transition: { duration: 1.5, repeat: Infinity, repeatType: "loop", ease: "easeInOut" },
  };

  const bounceAnimationLeft = {
    x: [0, -20, 0],
    transition: { duration: 1.5, repeat: Infinity, repeatType: "loop", ease: "easeInOut" },
  };

  const arrowSize = `clamp(36px, ${letterHeight * 0.12}px, 64px)`;
  const iconSize = `clamp(16px, ${letterHeight * 0.06}px, 32px)`;

  return (
    <section
      id="connect"
      className="min-h-screen w-full relative flex items-center justify-center"
      style={{ overflow: 'visible' }}
    >
      <AnimatePresence initial={false}>
        <motion.div
          key={`bg-${activeSlide}`}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 2.5, ease: 'easeInOut' }}
          className="absolute inset-0"
          style={{ backgroundColor: slides[activeSlide].bgColor }}
        />
      </AnimatePresence>

      <motion.button
        onClick={handleImagePrev}
        animate={bounceAnimationLeft}
        whileHover={{ scale: 1.2 }}
        whileTap={{ scale: 0.95 }}
        className="absolute top-1/2 -translate-y-1/2 bg-white/90 backdrop-blur-sm rounded-full shadow-lg hover:bg-white transition-all duration-300 z-40"
        style={{
          left: 'clamp(8px, 2vw, 48px)',
          width: arrowSize,
          height: arrowSize,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: 0,
          border: 'none',
          flexShrink: 0,
          cursor: 'pointer',
        }}
      >
        <svg viewBox="0 0 24 24" fill="none" style={{ width: iconSize, height: iconSize }}>
          <path d="M15 18L9 12L15 6" stroke="#A47F2D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </motion.button>

      <motion.button
        onClick={handleImageNext}
        animate={bounceAnimation}
        whileHover={{ scale: 1.2 }}
        whileTap={{ scale: 0.95 }}
        className="absolute top-1/2 -translate-y-1/2 bg-white/90 backdrop-blur-sm rounded-full shadow-lg hover:bg-white transition-all duration-300 z-40"
        style={{
          right: 'clamp(8px, 2vw, 48px)',
          width: arrowSize,
          height: arrowSize,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: 0,
          border: 'none',
          flexShrink: 0,
          cursor: 'pointer',
        }}
      >
        <svg viewBox="0 0 24 24" fill="none" style={{ width: iconSize, height: iconSize }}>
          <path d="M9 18L15 12L9 6" stroke="#A47F2D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </motion.button>

      <div className="w-full relative z-10 px-12 sm:px-16 md:px-20 lg:px-24">
        <div
          className="relative flex items-center justify-center mb-8 md:mb-16"
          style={{ minHeight: letterHeight + 60, overflow: 'visible' }}
        >
          <AnimatePresence mode="wait">
            <SlideWord
              key={activeSlide}
              slide={slides[activeSlide]}
              imageIndex={imageIndex}
              letterHeight={letterHeight}
              isSlideTransition={isSlideTransition}
            />
          </AnimatePresence>
        </div>

        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.3 }}
          className="flex justify-center gap-2 mb-8 md:mb-12"
        >
          {slides.map((_, index) => (
            <button
              key={index}
              onClick={() => handleSlideChange(index)}
              style={{
                width: '8px',
                height: '8px',
                padding: 0,
                minWidth: '8px',
                minHeight: '8px',
                border: activeSlide === index ? '1px solid white' : 'none',
                cursor: 'pointer',
              }}
              className={`rounded-full transition-all duration-300 ${
                activeSlide === index ? 'bg-transparent' : 'bg-white hover:bg-white/80'
              }`}
              aria-label={`Go to slide ${index + 1}`}
            />
          ))}
        </motion.div>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.5 }}
          className="text-white/80 text-center font-light max-w-4xl mx-auto mb-8 md:mb-12"
          style={{ fontSize: 'clamp(10px, 2vw, 18px)', lineHeight: '1.6' }}
        >
          MANY VOICES, ONE RHYTHM, DRAWN TOGETHER BY
          <br />
          MEMORY, PURPOSE, AND VISION
        </motion.p>

        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.7 }}
          className="flex justify-center"
        >
          <button
            style={{
              padding: 'clamp(8px, 1.5vw, 12px) clamp(20px, 3vw, 32px)',
              border: '1px solid rgba(255,255,255,0.8)',
              borderRadius: '50px',
              background: 'transparent',
              cursor: 'pointer',
              fontSize: 'clamp(8px, 1.5vw, 14px)',
              letterSpacing: '0.2em',
            }}
            className="text-white hover:text-[#A47F2D] hover:border-[#A47F2D] transition-all duration-300 hover:scale-105"
          >
            STEP INSIDE
          </button>
        </motion.div>
      </div>
    </section>
  );
};

export default ConnectSection;